import { render, staticRenderFns } from "./Procesos_producto.vue?vue&type=template&id=417d568a&scoped=true&"
import script from "./Procesos_producto.vue?vue&type=script&lang=ts&"
export * from "./Procesos_producto.vue?vue&type=script&lang=ts&"
import style0 from "./Procesos_producto.vue?vue&type=style&index=0&id=417d568a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417d568a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
